import { defineStore } from "pinia";
import { ref } from "vue";

import { resolveShortMentionType } from "shared/helpers/mentions";
import TranslationService from "shared/services/api/TranslationService";
import { type Excerpts, type Mention } from "shared/types/mentions";

export interface Translation {
  body: string;
  excerpts: Excerpts[];
  id: number;
  source_language: string;
  target_language: string;
  title: string;
  type: string; // eg "ON"
}

export const useTranslationStore = defineStore("translation", () => {
  const translations = ref<Translation[]>([]);

  function getTranslation(id: number) {
    return translations.value.find((translation) => translation.id === id);
  }

  async function fetchMentionTranslation(mention: Mention) {
    const type = resolveShortMentionType(mention.type);
    const keywords = mention.keywords ? Object.keys(mention.keywords) : [];

    const { data } = await TranslationService.index({
      params: {
        items: [
          {
            id: mention.id,
            keywords,
            type,
          },
        ],
      },
    });

    const [translation] = data;

    const index = translations.value.findIndex(
      (item) => item.id === translation.id
    );

    if (index !== -1) {
      translations.value.splice(index, 1, translation);
    } else {
      translations.value.push(translation);
    }
  }

  function resetTranslations() {
    translations.value = [];
  }

  return {
    fetchMentionTranslation,

    getTranslation,
    resetTranslations,
    translations,
  };
});
